export default {
      id: "qr-code-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#qr-code",
      toString: function () {
        return this.url;
      }
    }